(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["michal-product-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('michal-product-tabs')) {
    customElements.define('michal-product-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-enhanced')) return;
        this.panels = Array.from(this.children).filter(panel => panel.hasAttribute('data-product-tab'));
        if (this.panels.length < 2) return;
        this.style.setProperty('--tab-count', this.panels.length);
        this.list = document.createElement('div');
        this.list.className = 'michal-product-tabs__list';
        this.list.setAttribute('role', 'tablist');
        this.list.setAttribute('aria-label', this.dataset.label);
        this.list.setAttribute('aria-orientation', 'horizontal');
        this.tabs = this.panels.map((panel, index) => {
          const tab = document.createElement('button');
          tab.type = 'button';
          tab.className = 'michal-product-tabs__tab';
          tab.id = `${this.id}-tab-${index}`;
          tab.textContent = panel.dataset.productTab;
          tab.setAttribute('role', 'tab');
          panel.id = `${this.id}-panel-${index}`;
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          panel.tabIndex = 0;
          tab.setAttribute('aria-controls', panel.id);
          tab.addEventListener('click', () => this.select(index, false, true));
          tab.addEventListener('keydown', event => {
            let next;
            const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
            if (event.key === 'ArrowRight') next = index + direction;
            if (event.key === 'ArrowLeft') next = index - direction;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.select((next + this.tabs.length) % this.tabs.length, true, true);
          });
          this.list.append(tab);
          return tab;
        });
        this.prepend(this.list);
        this.setAttribute('data-enhanced', '');
        this.select(0);
        this.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.contains(event.target));
          if (index !== -1) this.select(index, false, true);
        });
      }

      select(index, focus = false, reveal = false) {
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[tabIndex].hidden = !selected;
        });
        const tab = this.tabs[index];
        if (focus) tab.focus({ preventScroll: true });
        if (reveal) {
          const listBounds = this.list.getBoundingClientRect();
          const tabBounds = tab.getBoundingClientRect();
          if (tabBounds.left < listBounds.left) this.list.scrollLeft += tabBounds.left - listBounds.left;
          if (tabBounds.right > listBounds.right) this.list.scrollLeft += tabBounds.right - listBounds.right;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
